export enum ERROR_MESSAGE {
  'NO_STORYBLOK_CONTENT' = 'This story has no content. Check the Content Tab in Storyblok',
}
